/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";
import { debounce } from "debounce";

/*------------------------------------*\
    EXAMPLE MODULE
\*------------------------------------*/
class ImageGallery {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.galleryItems = self.elem.querySelector('.js-image-gallery-items');
        self.galleryImageLarge = self.elem.querySelector('.js-image-gallery-large');
        self.galleryImageLargeWrapper = self.elem.querySelector('.js-image-gallery-large-wrapper');
        self.galleryItemLinks = self.elem.querySelectorAll('.js-image-gallery-link');
        self.galleryCaption = self.elem.querySelector('.js-image-gallery-caption');
        self.carouselBreakpoints = ['xs', 'sm'];
    }

    init() {
        let self = this;

        // Init carousel on page load (if at xs or sm breakpoints)
        self.initCarousel();

        // Init carousel on window resize (if at xs or sm breakpoints)
        window.addEventListener('resize', evt => {
            debounce(self.initCarousel(), 200);
        });

        self.galleryItemLinks.forEach(item => {
            let hasCaption = item.hasAttribute('data-caption');

            item.addEventListener('click', evt => {
                evt.preventDefault();

                self.galleryImageLargeWrapper.classList.add('is-loading');

                let newImage = new Image();

                newImage.onload = function () {
                    self.galleryImageLarge.src = this.src;

                    self.galleryImageLargeWrapper.classList.remove('is-loading');
                };

                newImage.src = item.getAttribute('href');

                // If there's a caption container...
                if (self.galleryCaption && hasCaption) {
                    self.galleryCaption.innerHTML = item.getAttribute('data-caption');
                }
            });
        });
    }

    initCarousel() {
        let self = this;

        let flkty = new Flickity(self.galleryItems, {
            cellAlign: 'left',
            wrapAround: true,
            prevNextButtons: false
        });

        if (!self.carouselBreakpoints.includes(self.getBreakpoint())) {
            flkty.destroy();
        }
    }

    getBreakpoint() {
        return window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
    }
}

export default ImageGallery;
